import { IOrganization } from "../../../reducers/course-author/types";

export enum SCORMExportQueryParams {
  TargetOrganization = "targetOrg",
  UseStrictMode = "useStrictMode",
  AssumePriorKnowledge = "assumePriorKnowledge",
  IncludeBranding = "includeBranding",
  Version = "scormVersion",
  HideLMSNavigationBar = "hideLmsNavbar",
  PrimaryKey = "scormPrimaryKey",
  LMS = "lms",
  PackageName = "packageName",
  AllowCourseReview = "allowCourseReview",
}

export type ExportOptions = ISCORMExportState["formValues"];

export interface ISCORMExportState {
  formValues: { [name in InputNames]: string | boolean };
  ownerOrg: IOrganization;
}

export enum InputNames {
  AdaptiveBranding = "adaptive-branding",
  AllowReview = "allow-review",
  ChooseOrganization = "choose-organization",
  HideNavbar = "hide-nav-bar",
  PackageName = "package-name",
  SelectLMS = "select-lms",
  SelectSCORMVersion = "select-scorm",
  SetParameters = "set-parameters",
  SelectedOrgId = "selected-org-id",
}

export const getDownloadUrl = (root: string, courseId: string, userId: string, exportOptions: ExportOptions) => {
  const baseUrl = `${root}/courses/${courseId}/_scormExport?activeUser=${userId}`;
  return baseUrl + foldQueryParametersWithValues(exportOptions);
};

const foldQueryParametersWithValues = (exportOptions: ExportOptions): string => {
  const queryParameterValues: { [key in SCORMExportQueryParams]: string } = {
    [SCORMExportQueryParams.AllowCourseReview]: `${exportOptions["allow-review"]}`,
    [SCORMExportQueryParams.AssumePriorKnowledge]: "false",
    [SCORMExportQueryParams.HideLMSNavigationBar]: `${exportOptions["hide-nav-bar"]}`,
    [SCORMExportQueryParams.IncludeBranding]: `${exportOptions["adaptive-branding"]}`,
    [SCORMExportQueryParams.LMS]: `${exportOptions["select-lms"]}`,
    [SCORMExportQueryParams.PackageName]: `${exportOptions["package-name"]}`,
    [SCORMExportQueryParams.PrimaryKey]: "ScormLearnerId",
    [SCORMExportQueryParams.TargetOrganization]: `${exportOptions["selected-org-id"]}`,
    [SCORMExportQueryParams.UseStrictMode]: `${exportOptions["set-parameters"] === "strict"}`,
    [SCORMExportQueryParams.Version]: `${exportOptions["select-scorm"]}`,
  };
  return Object.values(SCORMExportQueryParams).reduce(
    (queryParams: string, qp: SCORMExportQueryParams) =>
      queryParams + `&${qp}=${encodeURIComponent(queryParameterValues[qp])}`,
    ""
  );
};
